module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Daniel Kapexhiu - Head of Development","short_name":"Daniel","description":"Daniel Kapexhiu. Head of Development at a leading tech company, creating innovative web solutions","start_url":"/","background_color":"#a0d8f1","theme_color":"#a0d8f1","display":"standalone","icon":"static/logo-v2.jpg","legacy":true,"theme_color_in_head":false,"cache_busting_mode":"none","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
